import { EGetUserStatusActionType } from '../../actions/user';
import { TReduxActions } from '../../types/redux';
import { ERequestStatus } from '../../types/requestStatus';
import { TUserState } from '../../types/user';

const defaultState: TUserState = {
  status: ERequestStatus.Initial,
  isAuthenticated: false,
};

export function userReducer(state: TUserState = defaultState, action: TReduxActions): TUserState {
  switch (action.type) {
    case EGetUserStatusActionType.Loading:
      return {
        ...state,
        status: ERequestStatus.Loading,
      };
    case EGetUserStatusActionType.Succeed:
      return {
        status: ERequestStatus.Succeed,
        ...action.payload,
      };
    case EGetUserStatusActionType.Failed:
      return {
        ...state,
        status: ERequestStatus.Failed,
      };
    default:
      return state;
  }
}
